import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';
import { dataHooks } from './Ticker.constants';

export const tickerDriverFactory = (base: UniDriver) => {
  const upTicker = base.$(`[data-hook="${dataHooks.tickerUp}"]`);
  const downTicker = base.$(`[data-hook="${dataHooks.tickerDown}"]`);

  return {
    ...baseUniDriverFactory(base),
    clickUp: () => upTicker.click(),
    clickDown: () => downTicker.click(),
    isUpDisabled: async () => (await upTicker.attr('data-disabled')) === 'true',
    isDownDisabled: async () =>
      (await downTicker.attr('data-disabled')) === 'true',
  };
};
